import { LS } from '@/helpers/localStorageHelper';
import { disciplineIds } from '@/config/constants';

export const getDisciplinesViews = (isDefaultSortingByTournaments = false): DisciplineViews => {
  const savedViews = JSON.parse(LS.get('disciplineViews')) || {};

  return disciplineIds.reduce<DisciplineViews>((acc, id) => {
    if (isDefaultSortingByTournaments) {
      acc[id] = '1';
      return acc;
    }

    acc[id] = savedViews[id] || '0'; // Sort by time
    return acc;
  }, {} as DisciplineViews);
};

type DisciplineId = (typeof disciplineIds)[number];
type DisciplineViews = Record<DisciplineId, '0' | '1'>;
